/**
 * Toast Constants
 * Shared constants for toast notifications
 */

export const TOAST_DURATION = 5000;
export const TOAST_ANIMATION_DURATION = 300;

